import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Today',
    asap: 'ASAP',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Room number',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Table number',
  },
};
